export default {
    getReadWidget:   () => '<ma-time-of-day field="::field" values="::entry.values"></ma-time-of-day>',
    getWriteWidget:  () => '<ma-time-of-day-input field="::field" value="value"></ma-time-of-day-input>'
};



// WEBPACK FOOTER //
// ./js/types/TimeOfDayFieldView.js